module.exports = __webpack_public_path__ + "img/arrows.6b167955.svg";